<template>
    <v-card
            max-width="475"
            class="mx-auto"
            style="float:left;margin-bottom:20px;position:relative;left:20px;margin-top:5px;"
            dense
    >


        <v-list
                two-line
                subheader
                dense
        >


            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Primary DNS (1)</v-list-item-title>
                    <v-list-item-subtitle>136.244.87.61</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Secondary DNS (2)</v-list-item-title>
                    <v-list-item-subtitle>136.244.87.61</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>




    </v-card>
</template>
<style scoped>

    >>> .v-list-item.theme--light {
        min-height:40px;
    }

    >>> v-list-item__content {
        padding:0;
    }

    >>> .v-list--dense{
        padding:0;
    }

</style>
<script>


export default {
  name: 'DnsIpList',


}
</script>